import { CheckCircleIcon } from "@heroicons/react/20/solid";

export default function Success({ children }) {
  return (
    <div className="rounded-md bg-green-50 p-2 my-[20px]">
      <div className="flex">
        <div className="flex-shrink-0">
          <CheckCircleIcon
            aria-hidden="true"
            className="h-5 w-5 text-green-400"
          />
        </div>
        <div className="ml-3 ">
          <p
            className="text-sm font-medium text-green-800 word none break-all"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        </div>
      </div>
    </div>
  );
}
